export default __webpack_public_path__ + "static/media/cpcc-house.1702de0f.svg";